import { Vehicle } from 'rest-client';

import { VehicleData } from '@shared/models/vehicle-data.model';

export class SetVehicleAction {
  static readonly type = '[VEHICLE] Set vehicle';
  constructor(public vehicle: Vehicle, public vehicleData: VehicleData) {}
}
export class RemoveVehicleAction {
  static readonly type = '[VEHICLE] Remove vehicle';
}
